import {
  useFloating,
  offset,
  flip,
  shift,
  autoUpdate,
} from '@floating-ui/react';
import { Popover } from '@headlessui/react';
import { IconListFilter } from '@iwoca/icons';
import { Column } from '@tanstack/react-table';
import { createPortal } from 'react-dom';
import { TIntroducerListItem } from '../UsersTable.types';
import styles from './Filter.module.css';
import { SelectColumnFilter } from './SelectColumnFilter';

export const Filter = ({
  column,
}: {
  column: Column<TIntroducerListItem, unknown>;
}) => {
  const isFilterApplied = column.getIsFiltered();

  const { refs, floatingStyles } = useFloating({
    placement: 'bottom-start',
    middleware: [offset(4), flip(), shift({ padding: 8 })],
    whileElementsMounted: autoUpdate,
  });

  return (
    <Popover className={styles.container}>
      {({ open, close }) => (
        <>
          <Popover.Button
            ref={refs.setReference}
            className={styles.filterToggle}
            data-testid={`${column.id}-filter-toggle`}
            aria-label={`Filter ${String(column.columnDef.header)}`}
          >
            <IconListFilter height={16} width={16} />
            {isFilterApplied && <div className={styles.indicator} />}
          </Popover.Button>
          {open &&
            createPortal(
              <Popover.Panel
                static
                ref={refs.setFloating}
                className={styles.filterCard}
                style={floatingStyles}
              >
                <SelectColumnFilter column={column} onClose={close} />
              </Popover.Panel>,
              document.body,
            )}
        </>
      )}
    </Popover>
  );
};
